import { render } from "./OperatorChatWindow.vue?vue&type=template&id=1461608a&scoped=true"
import script from "./OperatorChatWindow.vue?vue&type=script&lang=js"
export * from "./OperatorChatWindow.vue?vue&type=script&lang=js"

import "./OperatorChatWindow.vue?vue&type=style&index=0&id=1461608a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1461608a"]])

export default __exports__